import { Color23, Colors23 } from '@grammarly/badger-ui'
import styles from './chevron.module.scss'

export enum ChevronDirection {
  right = 'right',
  up = 'up',
  left = 'left',
  down = 'down',
}
interface ChevronProps {
  color?: Color23
  direction?: ChevronDirection
  width?: string
  height?: string
  strokeWidth?: string
}

function getDirectionClassName(direction: ChevronDirection) {
  return {
    [ChevronDirection.right]: undefined,
    [ChevronDirection.up]: styles.up,
    [ChevronDirection.down]: styles.down,
    [ChevronDirection.left]: styles.left,
  }[direction]
}

export const Chevron = ({
  color,
  direction = ChevronDirection.right,
  width = '11',
  height = '11',
  strokeWidth = '1',
}: ChevronProps) => (
  <svg className={getDirectionClassName(direction)} width={width} height={height} viewBox="0 0 11 11" fill="none">
    <path
      data-link="chevron"
      d="M5.22513 10.0231L9.52311 5.72513L5.29797 1.5"
      stroke={color ? Colors23[color] : 'currentColor'}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
    />
  </svg>
)
